module.exports = __webpack_public_path__ + "img/2-2.efb44fb0.svg";